/**
 * Language resource for validation messages.
 * @typedef {Object} ValidationMessages
 * @property {string} password - Validation message for password field when it's empty.
 * @property {string} confirmPassword - Validation message for confirm password field when it's empty.
 * @property {string} passwordField - Validation message for password field when it doesn't meet criteria.
 * @property {string} email - Validation message for email field when it's empty.
 * @property {string} validEmail - Validation message for email field when it's not valid.
 * @property {string} minPhone - Validation message for phone number field when it's less than the minimum length.
 * @property {string} phone - Validation message for phone number field when it's empty.
 * @property {string} countryCode - Validation message for country code field when it's empty.
 * @property {string} phoneNumberReq - Validation message for phone number field when it's empty.
 * @property {string} newPassword - Validation message for new password field when it's empty.
 * @property {string} confirmPasswordField - Validation message for confirm password field when it doesn't match new password.
 * @property {string} currentPassword - Validation message for current password field when it's empty.
 */

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */

export const validation = {
  password: "Please enter a Password",
  confirmPassword: "Please enter confirm password",
  passwordField:
    "Password should be atleast 6 to 12 character,\nOne Uppercase, One Lowercase,\nOne Number & special Character",
  email: "Please enter a email ",
  validEmail: "Please enter a valid email address",
  minPhone: "Phone number must be 6 to 16 digits",
  phone: "Phone number is required",
  countryCode: "Country code is required",
  phoneNumberReq: "Please enter the phone number",
  newPassword: "Please enter new password",
  // confirmPassword: "Please enter confirm password",
  confirmPasswordField: "New Password and Confirm Password must be the same",
  currentPassword: "Please enter your current password",
  name: "Please enter name",
  validName: "Please enter valid name",
  desc: "Please enter description",
};
